import { RECEIVE_CUSTOMER_TESTIMONIALS_DATA } from "../actions/customerTestimonialsActions";

const initialState = {};

export default function customerTestimonialsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_CUSTOMER_TESTIMONIALS_DATA:
      return {
        ...state,
        customerTestimonials: [...action.payload]
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/customerTestimonialsReducer.js